import React, { FC } from 'react';
import { Breakpoint } from '@altibox/design-system-component-lib';

import { Link } from 'app/components/link';
import { LinkTheme } from 'app/components/link/types';

import { StyledLinkContainer } from './footer-external-link.styled';

interface Props {
    label: string;
    url: string;
}

export const FooterExternalLink: FC<Props> = (props) => {
    const { label, url } = props;

    return (
        <StyledLinkContainer>
            <Link variant="paragraph2" href={url} maxBreakpoint={Breakpoint.TABLET} $focusTheme={LinkTheme.DARK}>
                {label}
            </Link>
        </StyledLinkContainer>
    );
};
